var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"padding":"0px"},attrs:{"text-xs-center":"","fluid":"","wrap":""}},[_c('Dashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }